import React from "react";
import styled, { css } from "styled-components";

const DoctorsInsagramLinks = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 0;

    a 
    {
        display: inline-flex;
        align-items: center;
        align-content: center;
        color: #222;
        text-decoration: none;
        margin-bottom: 22px;

        &:not(:last-child):after 
        {
            content: ",";
            padding-left: 2px;
            padding-right: 15px;
        }

        img 
        {
            width: 18px;
            height: 18px;
            margin-right: 7px;
        }
    
        span 
        {
            color: #222;
            border-bottom: 1px dotted rgb(40 40 40 / 85%);
            transition: 0.25s;
        }

        :hover
        {
            span 
            {
                color: #222;
                border-bottom: 1px dotted transparent;
            }  
        }
    }


`


export default DoctorsInsagramLinks